import Card, { TitleCard, CardHeader } from "../core/Card"
import React from "react"

import { connect } from "react-redux"
import { bindActionCreators } from "redux"
import { Modal } from "antd"
import NewStripeForm from "./NewStripeForm"

import {
  createSubscription,
  createSubscriptionRequest,
  createSubscriptionFormRequest,
  createSubscriptionFormReset,
  updateCardRequest,
  updateCardFormRequest,
  updateCard,
  updateCardFormReset,
  updateSubscriptionRequest,
  updateSubscriptionFormReset,
  updateSubscription,
  // reactivateSubscription,
  // cancelSubscription,
  cancelReactivateSubscriptionFormReset,
  hideCreateSubscriptionSuccessModal,
  onCancelReactivateSubscriptionSubmit
} from "./actions"
import CreateSubscriptionSuccessModal from "./CreateSubscriptionSuccessModal"
import UpdateSubscriptionModal from "./UpdateSubscriptionModal"
import StripeForm from "./StripeForm"

import CancelReactivateSubscriptionModal from "./CancelReactivateSubscriptionModal"
import New from "./New"
import Manage from "./Manage"
// CONTAINERS:

export const CreateSubModal = connect(
  state => {
    const { ui } = state
    return {
      showModal: ui.showCreateSubscriptionSuccessModal,
      modalTitle: "Wohoo! You're now an Everlance Premium Member",
      buttonTitle: "Sounds Good"
    }
  },
  dispatch => {
    return {
      onCancel: () => dispatch(hideCreateSubscriptionSuccessModal())
    }
  }
)(CreateSubscriptionSuccessModal)

export const UpdateSubModal = connect(
  state => {
    const { ui, subs, models } = state
    return {
      form: ui.updateSubscriptionForm,
      showModal: subs.showUpdateSubscriptionModal,
      productIdentifier: subs.productIdentifier,
      modalTitle: "Update Subscription",
      buttonTitle: "Change Plan",
      buttonTitleSubmitting: "Updating...",
      total: subs.total / 100,
      interval: subs.interval,
      // quantity: subs.quantity,
      // NOTE teams owners used to have these props:
      // groupCoupon={enterprise_stripe_coupon}
      // groupCouponLabel="Prepay Discount"
      isGroup: !!models.user.group_as_enterprise_owner,
      customer:
        (models.user &&
          models.user.subscription &&
          models.user.subscription.customer) ||
        {}
      // pricePerActive: models.user.group_as_enterprise_owner.price_per_active
    }
  },
  dispatch => {
    return {
      ...bindActionCreators(
        { onUpdateSubscriptionSubmit: updateSubscription },
        dispatch
      ),
      onCancel: () => dispatch({ type: "CLOSE_SUB_MODAL" })
    }
  }
)(UpdateSubscriptionModal)

export const ManageStripeForm = connect(
  state => {
    const { ui, subs, models } = state
    return {
      form: ui.updateCardForm,
      showStripeModal: subs.showUpdateCardModal,
      modalTitle: "Update Payment Info",
      buttonTitle: "Save Payment Info",
      buttonTitleSubmitting: "Saving...",
      couponField: false,
      totalField: false,
      total: subs.total,
      interval: subs.interval,
      // quantity: subs.seats,

      // NOTE: do we need these?
      // groupCoupon:user.groupCoupon,
      isGroup: models.user.group_as_enterprise_owner,
      email: models.user.email,
      updateSourceOnly: true
    }
  },
  dispatch => {
    return {
      onCancel: () => dispatch({ type: "CLOSE_SUB_MODAL" }),

      ...bindActionCreators({ onReceiveStripeCardToken: updateCard }, dispatch)
    }
  }
)(StripeForm)

export const CancelOrReactivateSub = connect(
  state => {
    const { ui, subs, models } = state

    const { reactivating } = subs
    // TODO  showReactivateModal instead
    return {
      form: ui.cancelReactivateSubscriptionForm,
      showModal: subs.showCancelReactivateSubscriptionModal,
      modalTitle: reactivating
        ? "Reactivate Subscription"
        : "Cancel Subscription",
      buttonTitle: reactivating ? "Reactivate" : "Cancel",
      buttonTitleSubmitting: reactivating ? "Reactivating..." : "Canceling...",
      verifyPassword: !reactivating
    }
  },
  dispatch => {
    return {
      onCancel: () => dispatch({ type: "CLOSE_SUB_MODAL" }),
      ...bindActionCreators({ onCancelReactivateSubscriptionSubmit }, dispatch)
    }
  }
)(CancelReactivateSubscriptionModal)

export const SurveyModal = connect(
  state => ({
    showCancelSurveyModal: state.subs.showCancelSurveyModal,
    formUrl: state.models.user.group_as_enterprise_owner
      ? "https://goo.gl/forms/daF3XnFHZZz00Dcx1"
      : "https://docs.google.com/forms/d/e/1FAIpQLScMDG718Nz28oqd9SCgG-4xSk0noC71uglWswFOVRR9ElO61A/viewform?embedded=true"
  }),
  dispatch => ({
    handleCloseSurveyModal: () => dispatch({ type: "CLOSE_SURVEY_MODAL" })
  })
)(({ showCancelSurveyModal, handleCloseSurveyModal, formUrl }) => (
  <Modal
    visible={showCancelSurveyModal}
    onCancel={handleCloseSurveyModal}
    footer={null}
    width="80vw"
  >
    <iframe
      style={{ border: 0 }}
      src={formUrl}
      width="100%"
      height="500"
      frameborder="0"
      marginheight="0"
      marginwidth="0"
    >
      Loading...
    </iframe>
  </Modal>
))

const Placeholder = () => (
  <div>
    <Card style={{ height: 76 }} />
    <Card style={{ height: 200 }} showLoadingIcon />
  </div>
)

// route entry:
export default connect(state => state.models)(
  ({ user: { hasSubscription, group_as_enterprise_owner, isFetching } }) => (
    <div className="Premium">
      {isFetching && !hasSubscription ? (
        <Placeholder />
      ) : hasSubscription ? (
        <Manage />
      ) : (
        <New />
      )}
      <NewStripeForm />
      <CreateSubModal />
    </div>
  )
)



// WEBPACK FOOTER //
// ./src/subscriptions/index.js